export default __webpack_public_path__ + "static/media/P204.3.6cbac756.mp3";